import { Button, Col, DatePicker, Form, InputNumber, Row, Select } from "antd";
import PropTypes from "prop-types";

function Indexation(props) {
  const { Option } = Select;
  const { next, prev, handleCancel } = props;

  const onFinish = (values) => {
    console.log('Success:', values);
    next();
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };


  return (
    <div className="pt-3 stepper-basic-data">
      <h3 className="font-weight-bold mb-0 mt-1 pt-4 text-blue">
        Indexation
      </h3>
      <Form
        name="basic"
        className="user-modal flex-column justify-content-between d-flex"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        initialValues={{ remember: true }}
        autoComplete="off"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={24}>
          <Col xs={8}>
            <Form.Item label="Type" name="type" rules={[
              {
                required: true,
                message: 'Please input type',
              },
            ]}>
              <Select placeholder="Selection" allowClear>
                <Option value="1">None</Option>
                <Option value="2">CPI - Hurdle [%]</Option>
                <Option value="3">CPI - Hurdle [Pts.]</Option>
                <Option value="4">CPI - Period</Option>
                <Option value="5">Static</Option>
                <Option value="6">Stepping Rent</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={8}>
            <Form.Item label="Index" name="index" rules={[
              {
                required: true,
                message: 'Please input index',
              },
            ]}>
              <Select placeholder="Selection" allowClear>
                <Option value="1">VPI 15</Option>
                <Option value="2">VPI 10</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={8}>
            <Form.Item label="Last">
              <DatePicker placeholder="DD.MM.YYYY" className="w-100" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={8}>
            <Form.Item label="First">
              <DatePicker placeholder="DD.MM.YYYY" className="w-100" />
            </Form.Item>
          </Col>
          <Col xs={8}>
            <Form.Item label="Next">
              <DatePicker placeholder="DD.MM.YYYY" className="w-100" />
            </Form.Item>
          </Col>
          <Col xs={8}>
            <Form.Item label="Cycle">
              <InputNumber placeholder="Months" className="w-100" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={8}>
            <Form.Item label="Hurdle">
              <InputNumber placeholder="PTS. / %" className="w-100" />
            </Form.Item>
          </Col>
          <Col xs={8}>
            <Form.Item label="Factor">
              <InputNumber placeholder="%" className="w-100" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24} className="stepper-action-btn">
          <Col xs={24}>
            <div className="steps-action d-flex justify-content-between align-items-center mt-3">
              <div>
                <Button
                  style={{
                    margin: "0 8px",
                  }}
                  className="btn-primary"
                  onClick={prev}
                >
                  Previous
                </Button>
                <Button
                  style={{
                    margin: "0 8px",
                  }}
                  className="btn-cancel"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </div>
              <div>
                <Button type="primary" className="btn-primary" htmlType="submit">
                  Next
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default Indexation;

Indexation.propTypes = {
  next: PropTypes.node.isRequired,
  handleCancel: PropTypes.node.isRequired,
  prev: PropTypes.node.isRequired,
};
